<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">邀约带面</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <div v-show="!isShowDetail">
      <section>
        <section class="searchStyle">
          <span class="addStyle">
            <a-button v-show="!showIsSearch" @click="showIsSearch = true"
              >显示更多</a-button
            >
            <a-button v-show="showIsSearch" @click="showIsSearch = false"
              >隐藏更多</a-button
            >
            <!-- <a-button type="primary" icon="cloud-download" @click="addHideIs=!addHideIs">任务派发</a-button> -->
          </span>
          <span v-show="showIsSearch">
            <label>是否完成任务：</label>
            <a-radio-group v-model="manager_end_task">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </span>
          <span v-show="showIsSearch">
            <label>是否到面：</label>
            <a-radio-group v-model="is_interview">
              <a-radio :value="2">到面</a-radio>
              <a-radio :value="1">未到面</a-radio>
            </a-radio-group>
          </span>
          <span v-show="showIsSearch">
            <label>一级项目：</label>
            <a-select
              :allowClear="true"
              showSearch
              :filterOption="filterOption"
              v-model="selectedOneVal"
              @change="selectedOne"
              placeholder="请选择项目"
              style="width: 160px"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, i) in proListOne"
                :key="i"
                >{{ item.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span v-show="isShowTwo && showIsSearch">
            <label>省级项目：</label>
            <a-select
              :allowClear="true"
              v-model="selectedTwoVal"
              @change="selectedTwo"
              showSearch
              :filterOption="filterOption"
              placeholder="请选择项目"
              style="width: 160px"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, i) in proListTwo"
                :key="i"
                >{{ item.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span>
            <label>项目：</label>
            <a-select
              :allowClear="true"
              v-model="selectedThreeVal"
              showSearch
              :filterOption="filterOption"
              placeholder="请选择项目"
              style="width: 160px"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, i) in proListThree"
                :key="i"
                >{{ item.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span v-show="showIsSearch">
            <a-select
              v-model="time_type"
              style="width: 120px;margin-right:6px;"
            >
              <a-select-option :value="1">创建日期</a-select-option>
              <a-select-option :value="2">邀约日期</a-select-option>
              <a-select-option :value="3">面试日期</a-select-option>
              <a-select-option :value="4">带面日期</a-select-option>
            </a-select>
            <a-range-picker
              v-model="date"
              :ranges="{
                今天: [moment(), moment()],
                本月: [moment().startOf('month'), moment()],
                上月: [
                  moment()
                    .month(moment().month() - 1)
                    .startOf('month'),
                  moment()
                    .month(moment().month() - 1)
                    .endOf('month')
                ]
              }"
              :placeholder="['开始时间', '结束时间']"
              @change="onChangeDate"
            />
          </span>
          <span v-show="showIsSearch" class="nameSearchStyle">
            <a-select
              v-model="query_type"
              style="width: 100px;margin-right:6px;"
            >
              <a-select-option :value="1">简历</a-select-option>
              <a-select-option :value="2">邀约人员</a-select-option>
              <a-select-option :value="3">带面人员</a-select-option>
            </a-select>
            <a-input
              placeholder="请输入姓名|手机号"
              style="width:160px"
              v-model="query_info"
            />
          </span>
          <span>
            <a-button @click="onReset" class="resetStyle">重置</a-button>
            <a-button type="primary" icon="search" @click="onSearch"
              >搜索</a-button
            >
          </span>
        </section>
        <!-- 增加&搜索 end -->
        <!-- 列表内容 -->
        <section class="tableStyles">
          <table>
            <thead>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </thead>
            <tbody>
              <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
                <td>{{ item.project_name }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.age }}</td>
                <td>
                  <p v-show="item.on_job == 1">在职</p>
                  <p v-show="item.on_job == 0">不在职</p>
                </td>
                <td>{{ item.create_time }}</td>
                <td>
                  {{ item.invite_user_name }}
                </td>
                <td>
                  {{
                    item.interview_date + "&nbsp;&nbsp;" + item.interview_time
                  }}
                </td>
                <td>{{ item.manager_user_name }}</td>
                <td>
                  <p
                    v-show="
                      item.manager_end_task == 1 && item.is_interview == 2
                    "
                  >
                    是
                  </p>
                  <p
                    v-show="
                      item.manager_end_task == 1 && item.is_interview == 1
                    "
                  >
                    否
                  </p>
                  <p v-show="item.manager_end_task == 0 && item.is_cancel == 1">
                    未处理
                  </p>
                  <p v-show="item.manager_end_task == 0 && item.is_cancel == 2">
                    已取消
                  </p>
                </td>
                <td class="operation">
                  <a @click="detailPage(item.id)">详情</a>
                </td>
              </tr>
              <tr v-show="data == ''">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>暂无</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </section>
        <!-- 列表内容 end -->
        <div class="paginationStyle">
          <a-pagination
            showQuickJumper
            :defaultCurrent="page"
            :total="pagination.total"
            @change="onChange"
            :current="page"
          />
          <span>{{ "共：" + pagination.total + "条" }}</span>
        </div>
      </section>
    </div>
    <!-- 详情 -->
    <invitationDetail v-show="isShowDetail" :detailID="detailID" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import invitationDetail from "@/components/resume/invitationDetail"; //详情
export default {
  data() {
    return {
      page: 1,
      pagination: {},
      showIsSearch: false,
      query_field: "",
      interview_result: "",
      is_interview: "",
      manager_end_task: -1,
      proList: [],
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      thList: [
        "应聘项目",
        "姓名",
        "手机号",
        "年龄",
        "状态",
        "邀约时间",
        "邀约人员",
        "面试时间",
        "带面人员",
        "是否到面",
        "操作"
      ],
      data: [],
      isShowDetail: false,
      detailID: "",
      query_type: 1,
      query_info: "",
      time_type: 1,
      time_type_start: "",
      time_type_end: "",
      date: null
    };
  },
  mounted() {
    this.getProOne(); //获取一级项目列表
    this.getPro(); //获取项目
    this.getData(); //获取列表
  },
  components: {
    invitationDetail
  },
  methods: {
    moment,
    onChangeDate(date, dateString) {
      this.time_type_start = dateString[0];
      this.time_type_end = dateString[1];
    },
    detailPage(id) {
      this.detailID = id;
      this.isShowDetail = true;
    },
    getData() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_task/companyAssignResumeTaskList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        is_interview: this.is_interview,
        interview_result: this.interview_result,
        manager_end_task: this.manager_end_task,
        project_id: pro,
        query_type: this.query_type,
        time_type: this.time_type,
        query_info: this.query_info,
        time_type_start: this.time_type_start,
        time_type_end: this.time_type_end
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.data = res.data.data.data;
          const pagination = { ...this.pagination };
          pagination.total = res.data.data.total;
          this.pagination = pagination;
          //   console.log(this.data);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    backHref() {
      this.showIsRedeploy = false;
      this.isShowDetail = false;
      this.reload();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_type = 1;
      this.time_type = 1;
      this.query_info = "";
      this.time_type_start = "";
      this.time_type_end = "";
      this.date = null;
      this.query_field = "";
      this.project_id = "";
      this.is_interview = "";
      this.interview_result = "";
      this.manager_end_task = -1;
      this.open = false;
      this.page = 1;
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.getPro();
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchStyle {
  padding: 14px 2%;
  > span {
    display: inline-block;
    margin-right: 30px;
    margin-bottom: 16px;
    line-height: 32px;
    > div {
      display: inline-block;
      vertical-align: top;
    }
    label {
      line-height: 32px;
    }
    > button {
      margin-left: 10px;
    }
  }
}
</style>
